import { render, staticRenderFns } from "./InviterOrder.vue?vue&type=template&id=5536281a&scoped=true"
import script from "./InviterOrder.vue?vue&type=script&lang=js"
export * from "./InviterOrder.vue?vue&type=script&lang=js"
import style0 from "./InviterOrder.vue?vue&type=style&index=0&id=5536281a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536281a",
  null
  
)

export default component.exports